// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DragDrop {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
}

.DragDrop-File {
  width: 240px;
  height: 120px;
  border: 2px solid black;
  border-radius: 10px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.12s ease-in;
  font-size: 16px;
  font-weight: 600;
  color: #000;
  background-color: #fff;
}

.DragDrop-File-Dragging {
  background-color: black;
  color: white;
}

.DragDrop-Files {
  margin-top: 1rem;
}

.DragDrop-Files > div {
  width: 300px;
  padding: 8px;
  border: 2px solid black;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
}

.DragDrop-Files-Filter {
  cursor: pointer;
}

.DragDrop-Files-Filter:hover {
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/pages/component/common/fileupload/FileDragDrop.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EAEtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EAEtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".DragDrop {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.DragDrop-File {\r\n  width: 240px;\r\n  height: 120px;\r\n  border: 2px solid black;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  transition: 0.12s ease-in;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #000;\r\n  background-color: #fff;\r\n}\r\n\r\n.DragDrop-File-Dragging {\r\n  background-color: black;\r\n  color: white;\r\n}\r\n\r\n.DragDrop-Files {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.DragDrop-Files > div {\r\n  width: 300px;\r\n  padding: 8px;\r\n  border: 2px solid black;\r\n  margin-bottom: 10px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  border-radius: 6px;\r\n}\r\n\r\n.DragDrop-Files-Filter {\r\n  cursor: pointer;\r\n}\r\n\r\n.DragDrop-Files-Filter:hover {\r\n  opacity: 0.7;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
